<template>
  <div
  >
    <LoaderTuin :is-loading="loader" />

    <!-- Modal de suscripción expirada -->
    <SubscriptionExpiredModal
      :isVisible="showSubscriptionModal"
      @confirm="handleSubscriptionConfirm"
      @cancel="handleSubscriptionCancel"
    />

    <PropertyLimitModal
      :isVisible="showLimitModal"
      :currentCount="properties.length"
      :limit="propertyLimit"
      :planName="planName"
      @confirm="handleUpgradePlan"
      @cancel="closeLimitModal"
    />

    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        @close="closeToast"
      />
    </div>
    <!--New Design-->
    <div class="flex flex-col items-center justify-center w-full h-full bg-white mt-2.5 md:mt-6.5">
      <!-- Si no hay propiedades en absoluto (sin filtros activos) -->
      <div
        v-if="properties.length === 0 && !hasActiveFilters"
        class="flex flex-col sm:w-[520px] h-mx-auto"
      >
        <div class="grid grid-cols-1 gap-4 p-2 min-h-screen">
          <div class="flex flex-col justify-center items-center">
            <img src="@/assets/imgs/no_img_preview.svg" alt="">
            <span class="flex justify-center items-center text-lg font-normal text-center my-6">
              No tienes propiedades agregadas, te invitamos a que agregues a tus propiedades
            </span>
            <router-link
              :to="{ name: 'propertyForm' }"
              class="flex items-center space-x-2 text-white bg-tuin-100 hover:bg-tuin_hover p-2 rounded-lg"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 5.5C10.7652 5.5 11.0196 5.60536 11.2071 5.79289C11.3946 5.98043 11.5 6.23478 11.5 6.5V9.5H14.5C14.7652 9.5 15.0196 9.60536 15.2071 9.79289C15.3946 9.98043 15.5 10.2348 15.5 10.5C15.5 10.7652 15.3946 11.0196 15.2071 11.2071C15.0196 11.3946 14.7652 11.5 14.5 11.5H11.5V14.5C11.5 14.7652 11.3946 15.0196 11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071C9.60536 15.0196 9.5 14.7652 9.5 14.5V11.5H6.5C6.23478 11.5 5.98043 11.3946 5.79289 11.2071C5.60536 11.0196 5.5 10.7652 5.5 10.5C5.5 10.2348 5.60536 9.98043 5.79289 9.79289C5.98043 9.60536 6.23478 9.5 6.5 9.5H9.5V6.5C9.5 6.23478 9.60536 5.98043 9.79289 5.79289C9.98043 5.60536 10.2348 5.5 10.5 5.5Z" fill="white"/>
              </svg>
              <span class="ml-1">Agregar</span>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <FiltersSectionComponent
          v-if="(properties.length > 0) || hasActiveFilters"
          :type-Property="operations"
          :movements="movements"
          :status-list="status"
          :is-limit-reached="isLimitReached"
          :property-limit="propertyLimit"
          @search="handleSearch"
          @change-filter="handleFilterChange"
          @add-property="handleAddProperty"
        />
        <!-- Si hay filtros activos pero no se encontraron propiedades -->
        <div
          v-if="(filteredProperties.length === 0 && properties.length === 0 && hasActiveFilters) || (filteredProperties.length === 0 && properties.length > 0 && hasActiveFilters)"
          class="flex flex-col w-full min-h-screen"
        >
          <div class="flex flex-col justify-center items-center h-full min-h-[60vh] px-4">
            <img src="@/assets/imgs/no_img_preview.svg" alt="" class="mb-6 max-w-xs w-full">
            <span class="text-lg font-normal text-center text-gray-600 max-w-md">
              No se encontraron propiedades que coincidan con tu búsqueda
            </span>
          </div>
        </div>
        <div
          v-if="filteredProperties.length > 0"
          id="top" ref="topElement"
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5"
        >
        <!--New Card Design-->
          <div v-for="(item, index) in filteredProperties" :key="index">
            <CardPropertyComponent
              :property="item"
              @share="(p) => { openPropertyShareModal(p); callActionLog(p.property_id, 7, 'Usuario hizo clic en el botón de compartir propiedad desde Asesores'); }"
              @open-prospects="openProspects"
              @edit="(id) => goTo('edit', id)"
              @activate="({ property_id, status }) => activateOrDeactivateProperty(property_id, status)"
              @open-deactivate="openDeactivateModal"
              @remove="askRemoveProperty"
              @delete="openDeleteModal"
              @go-to-detail="({ property_id, is_associated }) => goToDetail(property_id, is_associated)"
              @open-agent="openAgentModal"
            />
          </div>
          <!--/New Card Design-->  
        </div>
        <div
          v-if="filteredProperties.length > 0"
          class="flex w-full md:justify-end justify-center items-center mt-10 mb-10"
        >
          <fwb-pagination
            v-model="currentPage"
            :total-pages="totalPages"
            @click="changePage()"
            previous-label="Anterior"
            next-label="Siguiente"
            :slice-length="1"
          >
            <template #page-button="{ disabled, page, setPage }">
              <button
                class="disabled:cursor-not-allowed ml-0 flex h-8 items-center justify-center border bg-white border-gray-300 px-3 leading-tight text-gray-500 first:rounded-l-lg last:rounded-r-lg"
                :class="{
                  'text-tuin-100': disabled
                }"
                  :disabled="disabled"
                  @click="setPage(page)"
                >
                  {{ page }}
              </button>
            </template>
          </fwb-pagination>
        </div>
      </div>
    </div>
    <!--New Design-->  
    <ModalLeadsComponent
      v-if="leadModal"
      :property-id="dbPropertyId" 
      :show-modal="leadModal"      
      @trigger-update="EventCloseModal"  
    />
    <DeletePropertie
      :isVisible="showDeleteModal"
      @confirm="confirmDelete"
      @cancel="closeModal"
    />
    <RemovePropertyModal
      :isVisible="showRemoveModal"
      @confirm="confirmRemoveProperty"
      @cancel="closeRemoveModal"
    />
    <PropertyShareModal
      v-if="showPropertyShareModal"
      :property-id="propertyToShare?.property_id"
      :property-name="propertyToShare?.property_name"
      :slug_url="propertyToShare?.slug_url"
      :property-code="propertyToShare?.property_code"
      @close="closePropertyShareModal"
      @copy-link="showToast('success', 'Enlace copiado al portapapeles')"
      @downloading-pdf="showToast('success', 'Preparando la ficha, Esto tarda unos segundos')"
      @error-downloading-pdf="showToast('danger', 'Error en la descarga del PDF')"
    />
    <AgentInfoModal
      v-if="showAgentModal"
      :show="showAgentModal"
      :agent="agentInfo"
      @close="closeAgentModal"
    />
    <DrawerComponent
      v-if="showAgentDrawer"
      :show="showAgentDrawer"
      :agent="agentInfo"
      @close="closeAgentDrawer"
    />
    <DeactivatePropertyModal
      :isVisible="showDeactivateModal"
      @confirm="confirmDeactivateProperty"
      @cancel="closeDeactivateModal"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted} from "vue";
import { useStore } from "vuex";
import axios from "axios";
import {
  FwbPagination
} from "flowbite-vue";
import { usePropertySync } from "@/composables/usePropertySync";
import LoaderTuin from "@/commond/LoaderTuin.vue";
import ModalLeadsComponent from "./modal/ModalLeadsComponent.vue";
import RemovePropertyModal from './modal/RemovePropertyModal.vue';
import PropertyShareModal from './modal/PropertyShareModal.vue';
import ToastAlert from '@/commond/ToastAlert.vue';
import DrawerComponent from './modal/AgentDrawer.vue';
import DeactivatePropertyModal from './modal/DeactivatePropertyModal.vue';
import SubscriptionExpiredModal from './modal/SubscriptionExpiredModal.vue';
import PropertyLimitModal from './modal/PropertyLimitModal.vue';
import { useRouter } from "vue-router";
import DeletePropertie from "./modal/DeletePropertie.vue";
import CardPropertyComponent from "@/components/properties/components/CardPropertyComponent.vue";
import FiltersSectionComponent from "@/components/properties/FiltersSectionComponent.vue";

const store = useStore();
let session = computed(() => store.getters.getUserSession);
const {
  syncWithPropiedades: syncWithPropiedadesShared,
  syncWithEasyBroker: syncWithEasyBrokerShared,
} = usePropertySync();

let router = useRouter();
const selectedUserId = ref(null);
const showDeleteModal = ref(false);
const showSubscriptionModal = ref(false);

function openDeleteModal(propertyId) {
  selectedUserId.value = propertyId;
  showDeleteModal.value = true;
}

let properties = ref([]);
let filteredProperties = ref([]);

// let error = ref({});
let searchQuery = ref(null);
let loader = ref(false);

let dbPropertyId = ref(null);
let leadModal = ref(false);

let currentPage = ref(1);
let totalPages = ref(1);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let filterTypeOperation   = ref('');
let filterTypeProperty = ref([]);
let subscriptionStatus = ref('');
let filterTypeStatus   = ref('');
let filterCurrency = ref('');
let filterMinPrice = ref('');
let filterMaxPrice = ref('');

function normalizeNumberValue(value) {
  if (!value) return '';
  return String(value).replace(/[^0-9]/g, '');
}

let operations  = [];
let movements   = [];
let status      = [];

const topElement = ref(null);  

const showRemoveModal = ref(false);  
const propertyIdToRemove = ref(null);  
const showPropertyShareModal = ref(false);  
const propertyToShare = ref(null);  

//Limite de propiedades
const currentPlanId = ref(null);  
const propertyLimit = ref(Infinity);  
const showLimitModal = ref(false);  
const planName = ref('')  

// NUEVO: Configuración de límites por plan
const PLAN_LIMITS = {
  1: { limit: 3, name: 'Plan Básico' },
  2: { limit: 5, name: 'Plan Plus' },
  3: { limit: 10, name: 'Plan Premium' },
  4: { limit: Infinity, name: 'Plan Enterprise' },
  5: { limit: 3, name: 'Plan Básico' },
  6: { limit: 5, name: 'Plan Plus' },
  7: { limit: 10, name: 'Plan Premium' },
  8: { limit: Infinity, name: 'Plan Enterprise' },
  9: { limit: 0, name: 'Plan Gratuito' }
};

const myPropertiesCount = ref();

const showPriceDropdown = ref(false)

function handleClickOutside(event) {
  const dropdown = document.getElementById('dropdownPrice')
  if (dropdown && !dropdown.closest('div').contains(event.target)) {
    showPriceDropdown.value = false
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onUnmounted(() => document.removeEventListener('click', handleClickOutside))

const isLimitReached = computed(() => {
  //console.log("esta es la cuenta: ",myPropertiesCount.value)
  return myPropertiesCount.value >= propertyLimit.value;
});

onMounted(async () => {
  loader.value = true;
  store.dispatch("updateStep", 3);
  await getTypeProperty();
  await getTypeOperation();
  await getTypeStatus();
  await checkSubscription();
  await get_propierties();
  await get_count_propierties();
  topElement.value = document.getElementById('top');
  loader.value = false;
});

const showDeactivateModal = ref(false);
const propertyIdToDeactivate = ref(null);
const isMobile = ref(false);

function checkScreenSize() {
  isMobile.value = window.innerWidth < 768;
}

onMounted(() => {
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize);
});

async function checkSubscription() {
  try {
    const options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/checkActive/${session.value.id}`,
      options
    );

    const data = response.data?.original;

    if (data) {
      const status = data.status;
      const planId = data.plan_id;
      
      // Guardar información del plan
      currentPlanId.value = planId;
      
      // Establecer límite de propiedades
      if (PLAN_LIMITS[planId]) {
        propertyLimit.value = PLAN_LIMITS[planId].limit;
        planName.value = PLAN_LIMITS[planId].name;
      }

      // Validaciones de suscripción
      if (status !== 'active') {
        subscriptionStatus.value = 'expired';
        showSubscriptionModal.value = true;
        //console.warn('Suscripción inactiva:', data.message);
        return;
      }

      // Segunda validación: si el plan es el gratuito (id = 9)
      if (planId === 9) {
        subscriptionStatus.value = 'expired';
        showSubscriptionModal.value = true;
        ///console.warn('Suscripción gratuita (no válida).');
        return;
      }

      // Si pasa ambas validaciones
      subscriptionStatus.value = 'active';
      showSubscriptionModal.value = false;

    } else {
      // Sin datos válidos en la respuesta
      subscriptionStatus.value = 'expired';
      showSubscriptionModal.value = true;
    }

  } catch (error) {
    //console.error('Error al verificar suscripción:', error);
    subscriptionStatus.value = 'expired';
    showSubscriptionModal.value = true;
  }
}

function handleAddProperty() {
  if (isLimitReached.value) {
    showLimitModal.value = true;
  } else {
    router.push({ name: 'propertyForm' });
  }
}
function closeLimitModal() {
  showLimitModal.value = false;
}

function handleUpgradePlan() {
  showLimitModal.value = false;
  router.push('/info-payments');
}
function handleSubscriptionConfirm() {
  showSubscriptionModal.value = false;
  router.push('/info-payments');
}

function handleSubscriptionCancel() {
  showSubscriptionModal.value = false;
  router.push('/home');
}

const openDeactivateModal = (propertyId) => {
  propertyIdToDeactivate.value = propertyId;
  showDeactivateModal.value = true;
};
const closeDeactivateModal = () => {
  showDeactivateModal.value = false;
  propertyIdToDeactivate.value = null;
};
const confirmDeactivateProperty = async () => {
  activateOrDeactivateProperty(propertyIdToDeactivate.value, 2);
  closeDeactivateModal();
};

// Computed para saber si hay filtros activos
const hasActiveFilters = computed(() =>
  !!searchQuery.value || filterTypeProperty.value.length > 0 || !!filterTypeOperation.value || !!filterTypeStatus.value || !!filterCurrency.value || !!filterMinPrice.value || !!filterMaxPrice.value
);

const activateOrDeactivateProperty = async (propertyId, newStatus) => {
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${propertyId}/change_status`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  // Cambia el status a 1 (activar) o 2 (desactivar)
  let param_post = { "status": newStatus };

  try {
    loader.value = true; // Activar loading durante el proceso
    
    const response = await axios.put(url_cnn, param_post, options);
    
    if (response.status === 200) {
      console.log("Propiedad actualizada correctamente.");
      
      // 🔄 Sincronización con plataformas externas según el nuevo estado
      await handleExternalPlatformSync(propertyId, newStatus);
      
      const statusText = newStatus === 1 ? 'activada' : 'desactivada';
      showToast('success', `Propiedad ${statusText} correctamente`);
      
      get_propierties(); // Refrescar la lista
    }
  } catch (error) {
    console.log("[ERROR]", error.response);
    showToast('danger', 'Error al cambiar el estado de la propiedad');
  } finally {
    window.location.reload();
    loader.value = false;
  }
};

// Nueva función para manejar la sincronización con plataformas externas
async function handleExternalPlatformSync(propertyId, newStatus) {
  // Primero obtener los partners de la propiedad específica
  const propertyPartners = await getPropertyPartners(propertyId);
  
  if (!propertyPartners) {
    console.log("⚠️ No se pudieron obtener los partners de la propiedad");
    return;
  }
  
  const easyBrokerPartner = propertyPartners.find(p => p.partner === 'EasyBroker');
  const propiedadesComPartner = propertyPartners.find(p => p.partner === 'PropiedadesCom');
  
  if (newStatus === 1) {
    // 🟢 ACTIVAR - Sincronizar con plataformas
    console.log("🟢 Activando propiedad - sincronizando con plataformas...");
    
    // EasyBroker Logic
    if (!easyBrokerPartner || (easyBrokerPartner.status !== 'active' && easyBrokerPartner.status !== 'delete')) {
      await syncWithEasyBroker(propertyId);
    } else if (easyBrokerPartner.status === 'delete') {
      await updateWithEasyBroker(propertyId);
    } else {
      console.log("✅ EasyBroker ya activo, no se hace nada.");
    }

    // PropiedadesCom Logic
    if (!propiedadesComPartner || propiedadesComPartner.status !== 'active') {
      await syncWithPropiedades(propertyId);
    } else {
      console.log("✅ PropiedadesCom ya activo, no se sincroniza.");
    }
    
  } else if (newStatus === 2) {
    // 🔴 DESACTIVAR - Eliminar de plataformas activas
    console.log("🔴 Desactivando propiedad - eliminando de plataformas...");
    
    // Solo eliminar de EasyBroker si está activo
    if (easyBrokerPartner && easyBrokerPartner.status === 'active') {
      await deleteFromEasyBroker(propertyId);
    } else {
      console.log("⏹ No se elimina de EasyBroker porque no está activo o no existe.");
    }
    
    // Para PropiedadesCom, no se elimina según la lógica del FormComponent
  }
}

// Función para obtener los partners de una propiedad específica
async function getPropertyPartners(propertyId) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/detail/property/${session.value.id}/${propertyId}`,
      {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      }
    );
    
    if (response.status === 200) {
      return response.data.resp.partners || [];
    }
  } catch (error) {
    console.error("Error al obtener partners de la propiedad:", error);
    return null;
  }
}

// Funciones de sincronización (adaptadas del ListPropertiesComponent)
async function syncWithPropiedades(propertyId) {
  return syncWithPropiedadesShared(propertyId, {
    onSuccess: () => {
      showToast('success', 'Sincronizado con PropiedadesCom');
    },
  });
}

async function syncWithEasyBroker(propertyId) {
  return syncWithEasyBrokerShared(propertyId, {
    endpoint: "enviar",
    onSuccess: () => {
      showToast('success', 'Sincronizado con EasyBroker');
    },
    onError: () => {
      showToast('danger', 'Error al sincronizar con EasyBroker');
    },
  });
}

async function updateWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("✅ Propiedad reactivada en EasyBroker");
      showToast('success', 'Reactivado en EasyBroker');
    } else {
      console.warn("⚠️ Error en respuesta de EasyBroker:", response.data);
    }
  } catch (error) {
    console.error("❌ Error al reactivar en EasyBroker:", error.response);
    showToast('danger', 'Error al reactivar en EasyBroker');
  }
}

const confirmDelete = async () => {

  // Activar loader instantáneamente y cerrar modal
  loader.value = true;
  showDeleteModal.value = false;
  
  let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${selectedUserId.value}/change_status`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  // Enviar el status como 3 (eliminado)
  let param_post = { "status": 3 };

  try {
    const response = await axios.put(url_cnn, param_post, options);
    
    if (response.status === 200) {
      //console.log("Propiedad eliminada en la base de datos local.");
      
      // 🔄 Llamar a la función para eliminar en propiedades.com
      await deleteFromPropiedades(selectedUserId.value);
      // 🔄 Llamar a la función para eliminar en Easy Broker
      await deleteFromEasyBroker(selectedUserId.value);

      // Mostrar mensaje de éxito y redirigir
      showToast('success', 'Propiedad eliminada correctamente');
      
      get_propierties(); // Refrescar la lista
    }
  } catch (error) {
    console.log("[ERROR]", error.response);
    loader.value = false;
  }
};
async function deleteFromPropiedades(propertyId) {
  let url = `${process.env.VUE_APP_API_BASE_URL}/propertiesComDelete/${propertyId}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.delete(url, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en propiedades.com");
    } else {
      console.log("Error al eliminar en propiedades.com", response.status);
    }
  } catch (error) {
    console.error("Error al eliminar en propiedades.com:", error);
  }
}
async function deleteFromEasyBroker(propertyId) {
  let url = `${process.env.VUE_APP_API_BASE_URL}/delete-easybroker/${propertyId}`;

  var options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, options);
    
    if (response.status === 200) {
      console.log("Propiedad eliminada en Easy Broker");
    } else {
      console.log("Error al eliminar en pEasy Broker", response.status);
    }
  } catch (error) {
    console.error("Error al eliminar en Easy Broker:", error);
  }
}
const closeModal = () => {
  showDeleteModal.value = false; // Cierra el modal
};
async function get_propierties() {
  loader.value = true;
  try {
    let url_cnn = '';
    
    url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/properties/${session.value.id}?page=${currentPage.value}`;

    // Agregar filtros a la URL
    if(filterTypeOperation.value != ''){
      url_cnn += `&type_operation=${filterTypeOperation.value}`
    }

    if(filterTypeProperty.value.length > 0){
      filterTypeProperty.value.forEach(id => {
        url_cnn += `&type_property[]=${id}`
      })
    }

    if(filterTypeStatus.value != ''){
      url_cnn += `&type_status=${filterTypeStatus.value}`
    }

    if(filterCurrency.value != ''){
      url_cnn += `&currency=${filterCurrency.value}`
    }

    if(filterMinPrice.value != ''){
      url_cnn += `&min_price=${normalizeNumberValue(filterMinPrice.value)}`
    }

    if(filterMaxPrice.value != ''){
      url_cnn += `&max_price=${normalizeNumberValue(filterMaxPrice.value)}`
    }

    var options = {
      headers: {
        "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
        Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
      },
    };

    const response = await axios.get(url_cnn, options);
    if (response.status == 200) {
      //console.log(response.data)
      properties.value = response.data.resp;
      filteredProperties.value = response.data.resp;
      let pages = response.data.pages;
      currentPage.value = pages.current_page;
      totalPages.value  = pages.last_page;
      scrollToTop()
    }
       
    loader.value = false;
  } catch (error) {
    console.error('ERROR', error)
    loader.value = false;
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}

async function get_count_propierties() {
  loader.value = true;
  try {
    let url_cnn = '';
    
    url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/properties_count/${session.value.id}`;

    var options = {
      headers: {
        "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
        Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
      },
    };

    const response = await axios.get(url_cnn, options);
    if (response.status == 200) {
      //console.log(response.data)
      myPropertiesCount.value = response.data.total_active_properties;
      //console.log('Propiedades encontradas',properties.value);
      scrollToTop()
    }
       
    loader.value = false;
  } catch (error) {
    console.error('ERROR', error)
    loader.value = false;
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}

async function removeProperty(property_id) {
  if (!session.value.id) {
    router.push({ name: "login" });
    return;
  }
  
  const post_params = {
    property_id: property_id,
    is_owner: false,
  };

  const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/remove_to_profile`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      console.log("✅ Propiedad eliminada:", response.data.message);
      // Actualizar la lista de propiedades después de eliminar
      await get_propierties();
    } else {
      console.log("⚠️ Hubo un error al eliminar la propiedad");
    }
  } catch (error) {
    console.log("❌ Error al eliminar la propiedad:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
  }
}
const scrollToTop = () => {
  if (topElement.value) {
    topElement.value.scrollIntoView({ behavior: 'smooth' });
  }
};


async function changePage(){
  //console.log('PAGE',currentPage.value)  
  get_propierties();
}

async function filterProperties(query) {
  const q = (query || '').toLowerCase();
  filteredProperties.value = properties.value.filter((property) => {
    return Object.keys(property).some((key) => {
      if (typeof property[key] === "string") {
        return property[key].toLowerCase().includes(q);
      }
      return false;
    });
  });
}

async function goTo(state, property_id) {
  router.push({ name: "propertyFormEdit", params: { id: property_id } });
}

async function goToDetail(property_id, is_associated = false) {
  if (is_associated) {
    // Propiedad asociada - usar PropertyDetailComponent
    router.push({
      name: "my_property_detail",
      params: { property_id: property_id },
    });
  } else {
    // Propiedad propia - usar MyPropertyDetailComponent
    router.push({
      name: "my_own_property_detail",
      params: { property_id: property_id },
    });
  }
}

async function openProspects(propertyId) {
  //console.log('propiedad',propertyId)
  dbPropertyId.value  = propertyId;
  leadModal.value   = true;
}

async function EventCloseModal(){
  console.log('cerro la modal')
  dbPropertyId.value  = null;
  leadModal.value     = false;
}

async function callActionLog(property_id, type_action, detail){
  let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
  let param_analytics = {
        "property_id":          property_id,
        "user_id":              session.value.id,
        "activity_id":          type_action,
        "description":          detail,          
  }
  console.log(param_analytics)

  let options = {
    headers: {
      "Content-Type": "application/json"
    },
  };

  try {
    const response = await axios.post(link, param_analytics, options);

    if (response.status == 401) {
      //console.log("Hay que sacarlo de la sesion ");
    }

    if (response.status == 200) {
      console.log(response);
    }
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

function askRemoveProperty(property_id) {
  propertyIdToRemove.value = property_id;
  showRemoveModal.value = true;
}
function closeRemoveModal() {
  showRemoveModal.value = false;
  propertyIdToRemove.value = null;
}
async function confirmRemoveProperty() {
  if (propertyIdToRemove.value) {
    removeProperty(propertyIdToRemove.value);
  }
  showRemoveModal.value = false;
  propertyIdToRemove.value = null;
}

function openPropertyShareModal(item) {
  propertyToShare.value = item;
  showPropertyShareModal.value = true;
}
function closePropertyShareModal() {
  showPropertyShareModal.value = false;
  propertyToShare.value = null;
}

import AgentInfoModal from './modal/AgentInfoModal.vue';

const showAgentModal = ref(false);
const showAgentDrawer = ref(false);
const agentInfo = ref({});

function openAgentModal(item) {
  agentInfo.value = {
    agent_id: item.agent_id,
    name: item.agent_name,
    phone: item.agent_phone || '',
    image: item.agent_avatar || '@/assets/imgs/broker_default.png',
    company_name: item.company_name,
    slugUrl: item.slug_url,
    propertyId: item.property_id
  };

  if (isMobile.value) {
    showAgentDrawer.value = true;
  } else {
    showAgentModal.value = true;
  }
}

function closeAgentModal() {
  showAgentModal.value = false;
}

function closeAgentDrawer() {
  showAgentDrawer.value = false;
}

async function change_filter() {
  currentPage.value = 1;
  get_propierties();
}

function handleSearch(query) {
  searchQuery.value = query;
  filterProperties(query);
}

function handleFilterChange(filters) {
  filterTypeOperation.value = filters.filterTypeOperation;
  filterTypeProperty.value  = filters.filterTypeProperty;
  filterTypeStatus.value    = filters.filterTypeStatus;
  filterCurrency.value      = filters.filterCurrency;
  filterMinPrice.value      = filters.filterMinPrice;
  filterMaxPrice.value      = filters.filterMaxPrice;
  change_filter();
}

async function getTypeProperty(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_property`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let type_operation = response.data.resp;  
      
      operations = type_operation.map(type => ({
          value: type.id,
          name: type.name
      }));
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function getTypeOperation(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let type_properties = response.data.resp;      

      movements = type_properties.map(type => ({
          value: type.id,
          name: type.name
      }));
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function getTypeStatus(){
  try {
    let options = {
      headers: {
        'conttent-type': 'json'
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_status_property`;

    const response = await axios.get(link, options);

    if (response.status == 200) {
      let type_properties = response.data.resp;      

      // Filtrar id 3, cambiar nombres de id 1 y 2, y agregar opción "Borrador"
      status = type_properties
        .filter(type => type.id !== 3) // Quitar status con id 3
        .map(type => {
          let name = type.name;
          if (type.id === 1) {
            name = 'Activadas';
          } else if (type.id === 2) {
            name = 'Desactivadas';
          }
          return {
            value: type.id,
            name: name
          };
        });
      
      // Agregar opción "Borrador" con value nulo al final
      status.push({
        value: null,
        name: 'Borrador'
      });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
</script>
<style scoped>
.alig-options{
  float: right; 
}
</style>